if (process.env.REACT_APP_SITE_CODE === 'ald88') {
  module.exports = require('./type.ald88')
} else {
  module.exports = require('./type.shy')
}
